/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { Component } from "react";
import { getMessage } from "utils/TranslationUtil";
import LiquidModeIcon from "dc-icons/viewer2021/Web_Mobile/SDC_TileLiquidMode_64.svg";
import { VERB_LIQUID_MODE, supportedFileExtensions } from "constants/enums";

class LiquidModeBootstrap extends Component {
  getLabel = () => getMessage("verb.liquidmode.label");

  getIcon = () => LiquidModeIcon;

  initializeAction = () => {};

  getFileSelectionParams = () => ({
    acceptExtensions: Object.values(supportedFileExtensions),
    acceptConnectors: "all"
  });

  id = VERB_LIQUID_MODE;

  render() {
    return null;
  }
}

export default LiquidModeBootstrap;
